
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div id="profile_dialog" class="vp-avatar-upload-dialog mail_folder-share_dialog">
  <vnc-header
    class="message"
    title="{{ 'SELECT_AVATAR' | translate }}"
    type="title-close"
    size="l"
    (onCloseClick)="close()"
    [showCloseIcon]="true"
    closeIconToolTip="{{ 'CLOSE' | translate }}">
  </vnc-header>
  <div class="mail__dialog-body cdk-virtual-scroll-viewport">
    <div class="main-body">
      <div class="left-item">
            <vnc-loader-circular [color]="'blue'" [size]="'xl'" class="avatar-upload-loader" *ngIf="!visible"></vnc-loader-circular>
            <div class="avatar-wrapper" [ngStyle]="{'visibility': visible && avatarSelected ? 'visible' : 'hidden' }" *ngIf="avatarSelected">
                <div class="cropper-container">
                    <vnc-image-cropper (onCropped)="imageCropped($event)" (onLoaded)="loadedImageForCrop($event)" (onError)="imageCropError($event)" [scale]="1"
                        uploadLabel="{{ 'UPLOAD' | translate }}">
                    </vnc-image-cropper>
                </div>

            </div>
      </div>
      <div class="right-item">
            <div class="item" *ngFor="let item of defaultCovers;index as i;">
                <vnc-gallery-component
                    [type]="'default'"
                    [isChecked]="i === indexItem ? true : false"
                    [coverImageURL]="item.url"
                    (itemClick)="selectIndexItem(i)"
                    [isMobile]="false"
                >
                </vnc-gallery-component>
            </div>
      </div>

    </div>

  </div>
  <div class="footer-avatar-upload-dialog">
     <mat-slider [ngStyle]="{'visibility': hideCropper? 'hidden': 'visible'}" color="primary" [(ngModel)]="scale"  [min]="min" step="0.01" [max]="max"></mat-slider>
     <vnc-footer [secondaryLabel]="'CANCEL_MAIL_LABEL' | translate | uppercase"
     [primaryLabel]="'APPLY_LBL' | translate | uppercase"
     [type]="'secondary-primary'"
     [color]="'white'"
     (onSecondaryClick)="close()"
     (onPrimaryClick)="saveUpload()">
   </vnc-footer>
  </div>
</div>
